import baseUrl from './baseUrl';

export default baseUrl === 'https://giztixgps.giztix.com' ? 'https://giztixgps.giztix.com' : 'https://demoapi.giztix.com';
